// Inter font is loaded via @font-face in /public/fonts/fonts.css
export const inter = {
  className: 'font-inter',
};
